import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatINR } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Printer, Download } from "lucide-react";

export default function DistributorStatement() {
    const [data, setData] = useState({ invoices: [], payments: [], orders: [], outstanding: 0, total_billed: 0, total_paid: 0 });
    const [from, setFrom] = useState(""); const [to, setTo] = useState("");
    const load = () => api.get("/distributors/statement", { params: { from_date: from || undefined, to_date: to || undefined } }).then(r => setData(r.data)).catch(() => {});
    useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

    return (
        <div data-testid="dist-statement" className="space-y-4">
            <div className="flex items-center justify-between">
                <div>
                    <div className="label-eyebrow text-sky-700">Account ledger</div>
                    <h1 className="font-serif text-4xl text-stone-900">Statement of account</h1>
                </div>
                <div className="flex gap-2">
                    <a href={`${(api.defaults.baseURL || "")}/distributor/statement.pdf`} target="_blank" rel="noreferrer" className="inline-flex items-center px-4 py-2 border border-sky-700 text-sm text-sky-700 hover:bg-sky-50" data-testid="download-statement-pdf">
                        <Download className="w-4 h-4 mr-2" />Download PDF
                    </a>
                    <Button onClick={() => window.print()} variant="outline" className="rounded-none border-stone-400" data-testid="print-statement"><Printer className="w-4 h-4 mr-2" />Print</Button>
                </div>
            </div>

            <div className="bg-white border border-stone-200 p-4 grid sm:grid-cols-3 gap-3 print:hidden">
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">From</Label><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="rounded-none border-stone-300 mt-1" /></div>
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">To</Label><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="rounded-none border-stone-300 mt-1" /></div>
                <div className="flex items-end"><Button onClick={load} className="rounded-none bg-sky-700 hover:bg-sky-800 text-stone-50">Apply</Button></div>
            </div>

            <div className="grid sm:grid-cols-3 gap-3">
                <KPI label="Billed" value={formatINR(data.total_billed)} />
                <KPI label="Paid" value={formatINR(data.total_paid)} />
                <KPI label="Outstanding" value={formatINR(data.outstanding)} highlight />
            </div>

            <div className="bg-white border border-stone-200">
                <div className="p-4 border-b border-stone-200 font-serif text-xl">Invoices</div>
                <table className="w-full text-sm">
                    <thead><tr className="text-xs uppercase tracking-widest text-stone-500 border-b border-stone-200">
                        <th className="text-left p-3">Number</th><th className="text-left p-3">Date</th><th className="text-right p-3">Total</th><th className="text-right p-3">Paid</th><th className="text-right p-3">Outstanding</th><th className="p-3"></th>
                    </tr></thead>
                    <tbody>
                        {data.invoices.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-stone-500">No invoices yet.</td></tr>}
                        {data.invoices.map(i => {
                            const paid = data.payments.filter(p => p.invoice_id === i.id).reduce((s, p) => s + p.amount, 0);
                            return (
                                <tr key={i.id} className="border-b border-stone-100" data-testid={`dist-inv-${i.invoice_number}`}>
                                    <td className="p-3 font-mono">{i.invoice_number}</td>
                                    <td className="p-3 text-stone-500">{i.created_at?.slice(0, 10)}</td>
                                    <td className="p-3 text-right">{formatINR(i.total)}</td>
                                    <td className="p-3 text-right">{formatINR(paid)}</td>
                                    <td className="p-3 text-right font-medium text-amber-700">{formatINR(i.total - paid)}</td>
                                    <td className="p-3 text-right"><Link to={`/invoice/${i.id}`} target="_blank" className="text-sky-700 underline text-xs"><Download className="w-3.5 h-3.5 inline" /> View</Link></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const KPI = ({ label, value, highlight }) => (
    <div className={`bg-white border ${highlight ? "border-amber-500" : "border-stone-200"} p-4`}>
        <div className="label-eyebrow text-stone-500">{label}</div>
        <div className={`font-serif text-2xl mt-1 ${highlight ? "text-amber-700" : "text-stone-900"}`}>{value}</div>
    </div>
);
